<template>
  <div
    class="order-widget-outside"
    :class="{ 'unset_error': error }"
  >
    <v-container class="order-widget">
      <Schedule
        v-if="dialog.schedule"
        :value="selected.schedule"
        :id="selected.schedule.id"
        :dialog="dialog.schedule"
        :schedules="groups.schedules"
        :services="order.list.services"
        @closed="onCloseDialog"
        @saved="saveSchedule"
      />
      <v-row class="ma-0">
        <v-tabs
          v-model="catalog"
          background-color="transparent"
          class="catalogs-tabs"
          dark
          grow
          show-arrows
        >
          <v-tabs-slider/>
          <v-tab href="#services">
            <v-icon class="pr-2">{{ lang.meta.pages.catalog.pages.services.icon }}</v-icon>
            {{ lang.meta.pages.catalog.pages.services.title }}
            <span v-if="(order.list.services || []).length > 0" class="order-catalog-count">{{ (order.list.services || []).length }}</span>
          </v-tab>
          <v-tab href="#items">
            <v-icon class="pr-2">{{ lang.meta.pages.catalog.pages.items.icon }}</v-icon>
            {{ lang.meta.pages.catalog.pages.items.title }}
            <span v-if="(order.list.items || []).length > 0" class="order-catalog-count">{{ (order.list.items || []).length }}</span>
          </v-tab>
        </v-tabs>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" class="pa-0">
          <AutoComplete
            :value="order.list"
            :catalog="catalog"
            @input="itemSelected"
            :label="lang.historic.filters.order.title"
            :key="catalog"
            :clearable="false"
            returnObject
            isOrder
            hideChips
          />
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" class="pa-0">
          <Toolbar
            :catalog="catalog"
            :key="catalog"
          />
        </v-col>
      </v-row>
      <v-row class="order-list">
        <List
          :value="order.list"
          :catalog="catalog"
          :groups="{ services: groups.schedules, items: groups.delivery }"
          @input="updatedList"
          @action="action"
          :key="catalog"
        />
      </v-row>
      <v-row class="pa-4 order-footer">
        <v-col cols="12" lg="7" md="7" sm="12" xs="12" class="order-obs">
          <v-textarea
            v-model="order.obs"
            :label="lang.orders.new.order.obs"
            rows="2"
            filled
            hide-details
          ></v-textarea>
        </v-col>
        <v-col cols="12" lg="5" md="5" sm="12" xs="12" class="order-total">
          <v-row>
            <v-col cols="5" class="prices">
              <p class="total">{{ lang.orders.new.subtotal }}: </p>
            </v-col>
            <v-col cols="7" class="prices">
              <p class="total">{{ formatCurrency(order.subtotal) }}</p>
            </v-col>
          </v-row>
          <!-- <v-row v-for="(fee, index) in other_fees" :key="index">
            <v-col cols="5" class="prices">
              <p class="subtotal">{{ fee.title }}: </p>
            </v-col>
            <v-col cols="7" class="prices">
              <p class="subtotal">{{ formatCurrency(fee.price) }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="5" class="prices">
              <p class="total">{{ lang.orders.datatable.headers.total }}: </p>
            </v-col>
            <v-col cols="7" class="prices">
              <p class="total">{{ formatCurrency(order.total) }}</p>
            </v-col>
          </v-row> -->
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AutoComplete from './templates/widget/autocomplete/Catalog'
import Toolbar from './templates/widget/Toolbar'
import List from './templates/widget/List'

import Schedule from '@/components/scheduler/Save'

import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { AutoComplete, Toolbar, List, Schedule },
  mixins: [ appdata, utils ],
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    error: {
      type: Boolean,
      default: false
    },
    schedules: {
      type: Array,
      default: () => {
        return []
      }
    },
    other_fees: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      catalog: 'services',
      order: { ...this.value },
      selected: {
        schedule: {},
        deliver: {}
      },
      groups: {
        schedules : [],
        delivery : []
      },
      dialog: {
        schedule: false,
        deliver: false
      }
    }
  },
  watch: {
    order: {
      deep: true,
      handler (newVal) {
        this.updatePriceTotal()
        if (JSON.stringify(newVal) !== JSON.stringify(this.value)) {
          this.$emit('input', this.order)
        }
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler (newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.order)) {
          this.order = { ...newVal }
          this.$forceUpdate()
        }
      }
    },
    'groups.schedules': {
      deep: true,
      immediate: true,
      handler (newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.schedules)) {
          this.$emit('schInput', this.groups.schedules)
        }
      }
    },
    schedules: {
      deep: true,
      immediate: true,
      handler (newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.groups.schedules)) {
          this.groups.schedules = [ ...newVal ]
          this.$forceUpdate()
        }
      }
    },
    other_fees: {
      deep: true,
      handler () {
        this.updatePriceTotal()
      }
    }
  },
  methods: {
    updatePriceTotal () {
      let array = Object.entries(this.order.list)
      const items = array.reduce((add, val) => add.concat(val[1]), [])
      var total = 0
      items.forEach(function (item) {
        var itemTotal = parseFloat(item.price * item.qty)
        var subtotal = 0
        var additional = (typeof item.adt !== 'undefined' && item.adt.length > 0 ? item.adt : [])
        additional.forEach(function (adt) {
          var adtPrice = parseFloat(adt.price)
          var adtQty = (adt.qty ? parseFloat(adt.qty) : 1)
          adtPrice = (adtPrice * adtQty)
          subtotal = parseFloat(subtotal + adtPrice)
          adt.total = adtPrice
        })
        itemTotal = parseFloat(itemTotal + (subtotal * item.qty))
        total = parseFloat(parseFloat(total) + itemTotal)
        item.total = itemTotal
      })
      this.order.subtotal = total
      this.other_fees.forEach(function (fee) {
        total = parseFloat(total + parseFloat(fee.price))
      })
      this.order.total = total
    },
    itemSelected ({ list, catalog }) {
      this.$set(this.order.list, catalog, [ ...list ])
      // this.order.list = [ ...items ]
    },
    updatedList ({ list, catalog }) {
      this.order.list[catalog] = [ ...list ]
      // this.$set(this.order.list, catalog, [ ...list ])
      this.updatePriceTotal()
      // this.order.list = [ ...items ]
    },

    saveSchedule (schedule) {
      console.log('saveSchedule', schedule)
      let schedules = this.groups.schedules || [],
          index = schedules.findIndex(e => e.UUID === schedule.UUID)
      if (index >= 0) {
        schedules[index] = { ...schedule }
        this.dialog.schedule = false
      } else {
        schedules.push({ ...schedule })
        this.dialog.schedule = false
      }
      return true
    },
    editSchedule (UUID, services = []) {
      let schedules = this.groups.schedules || [],
          index = schedules.findIndex(group => group.UUID === UUID),
          schedule = (index >= 0 ? { ...schedules[index] } : { ...defaults.blank.schedule })

      if (index < 0 && services.length > 0) {
        schedule.UUID = this.getRandomUnique()
        schedule.list = [ ...services ]
        schedule.selected = []
      } else if (index < 0) {
        return false
      }
      this.selected.schedule = { ...schedule }
      this.dialog.schedule = true
      return true
    },
    deleteSchedule (UUID) {
      let schedules = this.groups.schedules || [],
          index = schedules.findIndex(e => e.UUID === UUID)
      if (index >= 0 && schedules[index]) {
        if (schedules[index].id > 0) {
          schedules[index].delete = 1
          return true
        } else {
          return schedules.splice(index, 1)
        }
      }
      return false
    },
    deleteFromSchedule (UUID) {
      let groups = this.groups.schedules || [],
          group = groups.find(el => typeof el.list !== 'undefined' && el.list.findIndex(item => item === UUID) >= 0)
      if (group) {
        if (group.list.length <= 1) {
          this.deleteSchedule(group.UUID)
        } else {
          let index_ = group.list.findIndex(item => item === UUID)
          return (index_ >= 0 ? group.list.splice(index_, 1) : false)
        }
      }
      return false
    },

    // eslint-disable-next-line no-unused-vars
    editDelivery (items) {
      this.dialog.delivery = true
      return true
    },
    onCloseDialog () {
      this.dialog = {
        schedule: false,
        deliver: false
      }
    },
    newSchedule (services) {
      return this.groups.schedules.push({
        UUID: this.getRandomUnique(),
        list: [ ...services ]
      })
    },
    newDelivery (items) {
      return this.groups.delivery.push({
        UUID: this.getRandomUnique(),
        list: [ ...items ]
      })
    },
    editGroup (catalog, UUID = 0, list = []) {
      switch (catalog) {
        case 'services':
          return this.editSchedule(UUID, list)
        case 'items':
          return this.editDelivery(UUID, list)
      }
      return false
    },
    deleteGroup (catalog, UUID = false) {
      if (UUID) {
        switch (catalog) {
          case 'services':
            return this.deleteSchedule(UUID)
          case 'items':
            return this.deleteDelivery(UUID)
        }
      }
      return false
    },
    ungroupItem (catalog, UUID) {
      if (UUID) {
        switch (catalog) {
          case 'services':
            return this.deleteFromSchedule(UUID)
          case 'items':
            return this.deleteFromDelivery(UUID)
        }
      }
      return false
    },
    action ({ action, value }) {
      var rtrn = false
      if (value && typeof value.catalog !== 'undefined') {
        switch (action) {
          case 1:
            rtrn = this.viewGroup(value.catalog, value.UUID)
            break
          case 2:
            rtrn = this.editGroup(value.catalog, value.UUID, value.list || [])
            break
          case 3:
            rtrn = this.deleteGroup(value.catalog, value.UUID)
            break
          case 4:
            rtrn = this.ungroupItem(value.catalog, value.UUID)
            break
        }
        this.$forceUpdate()
      }
      return rtrn
    }
  },
  created () {
    this.updatePriceTotal()
  },
  mounted () {
    this.groups.schedules = [ ...this.schedules ] || []
    this.$forceUpdate()
  }
}
</script>

<style src="./styles/widget.scss" lang="scss"></style>
